export default {
  //PRODUCTS
  CREATE_PRODUCT(state, payload) {},
  GET_PRODUCT(state, payload) {
    state.singleProduct = payload;
  },
  GET_ALL_PRODUCT(state, payload) {
    state.products = payload;
  },
  UPDATE_PRODUCT(state, payload) {},
  DELETE_PRODUCT(state, payload) {},

  GET_ORDER(state, payload) {
    state.productOrder = payload;
  },

  GET_CART(state, payload) {
    state.cartData = payload;
  },
  GET_BRAND(state, payload) {
    state.brandData = payload;
  },
  GET_ALL_VENDOR(state, payload) {
    state.getAllVendor = payload;
  },
  GET_VENDOR_PRODS(state, payload) {
    state.vendorProds = payload;
  },
  GET_VENDOR(state, payload) {
    state.getVendor = payload;
  },
  ORDER_COUNT(state, payload) {
    state.orderCount = payload;
  },
  GET_AFFILIATE_URL(state, payload) {
    state.affiliateUrlData = payload;
  },
};
